import { render, staticRenderFns } from "./CovidMap.vue?vue&type=template&id=e2ed68c6&"
import script from "./CovidMap.vue?vue&type=script&lang=js&"
export * from "./CovidMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports